<template>
  <MtxPage>
    <div class="text-center mb-3">
      <MtxBlockie :input="userAddress" :options="{ scale: 12 }" class="mb-2" />
      <h3 class="mb-0">{{ userAddress | ethAddress }}</h3>
      <div class="color-muted break-word mb-2">
        {{ userAddress }}
        <Copy plain :text="userAddress" />
      </div>
    </div>

    <div class="text-center">
      <h1>Tournaments</h1>
      <template v-if="tournaments.length">
        <TournamentsList :tournaments="tournaments" />

        <div class="text-center my-4">
          <button v-if="hasMore" :disabled="isLoading" @click="loadMore">load more</button>
          <button v-else disabled>no more</button>
        </div>
      </template>

      <div v-else>
        This user has not created any Tournaments yet
      </div>
    </div>
  </MtxPage>
</template>

<script>
import TournamentsList from "@/components/tournaments/TournamentsList"
import API from "@/api"

export default {
  components: {
    TournamentsList
  },

  props: {
    userAddress: String
  },

  metaInfo() {
    return {
      titleTemplate: this.userAddress ? `%s | ${this.userAddress}` : "%s",
      meta: [
        {
          name: "description",
          content: this.userAddress ? `View a users Matryx profile` : ""
        }
      ]
    }
  },

  data: () => ({
    showFilters: false,
    hasMore: true,
    isLoading: false,
    tournaments: []
  }),

  async beforeRouteEnter(to, from, next) {
    const { success, data } = await API.getTournaments({
      owner: to.params.userAddress
    })

    if (success) {
      next(vm => vm.setTournaments(data.tournaments))
    }
  },

  methods: {
    setTournaments(tournaments) {
      this.tournaments = tournaments
    },

    async loadMore() {
      this.isLoading = true

      const { success, data } = await API.getTournaments({
        offset: this.tournaments.length,
        owner: this.userAddress
      })

      if (success) {
        this.tournaments.push(...data.tournaments)
        this.hasMore = !!data.tournaments.length
      }

      this.isLoading = false
    }
  }
}
</script>
